var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14 6.66699C14 11.3337 8 15.3337 8 15.3337C8 15.3337 2 11.3337 2 6.66699C2 5.07569 2.63214 3.54957 3.75736 2.42435C4.88258 1.29913 6.4087 0.666992 8 0.666992C9.5913 0.666992 11.1174 1.29913 12.2426 2.42435C13.3679 3.54957 14 5.07569 14 6.66699Z","stroke":"#345543","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 8.66699C9.10457 8.66699 10 7.77156 10 6.66699C10 5.56242 9.10457 4.66699 8 4.66699C6.89543 4.66699 6 5.56242 6 6.66699C6 7.77156 6.89543 8.66699 8 8.66699Z","stroke":"#345543","strokeWidth":"1.33333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Location.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Location;

Location.default = Location;
